import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/faq";

export default class Faq extends Page {
  title = "home";

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.getApp().addScripts();

    this.scrollToTop();
  }
}
